// @ts-nocheck
import React, { useEffect, useState } from 'react';
import fetchWithAuth from '../utils/fetchWithAuth.ts';
import { apiConfig } from '../config.js';
import { Link } from 'react-router-dom';
import { getAvatarURL } from '../utils/avatar.ts';
import BrandSpinner from '../components/ui/atoms/BrandSpinner/BrandSpinner.tsx';

const Community = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scrollEnabled, setScrollEnabled] = useState(false);

  const MAX_USERS_PER_PAGE = 10;

  const fetchUsers = async (page) => {
    if (page > 1 && (isFetching || !hasMore)) return;

    setIsFetching(true);
    try {
      const { users: newUsers, hasMore: more } = await fetchWithAuth(
        `/api/users?page=${page}&limit=${MAX_USERS_PER_PAGE}`
      );

      setUsers((prev) => (page === 1 ? newUsers : [...prev, ...newUsers]));
      setHasMore(more);

      if (page === 1) {
        setScrollEnabled(true);
      }
    } catch (err) {
      console.error('Error fetching users:', err);
      setHasMore(false);
    } finally {
      setIsFetching(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  useEffect(() => {
    if (!scrollEnabled || !hasMore) return;

    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isFetching) {
          const nextPage = currentPage + 1;
          setCurrentPage(nextPage);
          fetchUsers(nextPage);
        }
      },
      { threshold: 1 }
    );

    const trigger = document.getElementById('scroll-trigger');
    if (trigger) obs.observe(trigger);
    return () => obs.disconnect();
  }, [scrollEnabled, hasMore, isFetching, currentPage]);

  const filteredUsers = (users || []).filter((user) => {
    const fullName = `${user.name || ''}`.toLowerCase();
    const username = `${user.username || ''}`.toLowerCase();
    return fullName.includes(searchTerm) || username.includes(searchTerm);
  });

  return (
    <div className="px-4 pb-20 pt-4 max-w-3xl mx-auto">
      <input
        type="text"
        placeholder="Search users..."
        className="mb-4 w-full px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
      />

      {loading || (isFetching && users.length === 0) ? (
        <div className="text-center mt-10 text-gray-500">
          <BrandSpinner />
        </div>
      ) : filteredUsers.length === 0 ? (
        <p className="text-gray-600">No users found.</p>
      ) : (
        <>
          {filteredUsers.map((user) => (
            <Link
              key={user.id}
              to={`/app/profile/${user.id}`}
              className="block mb-3 hover:bg-gray-50 transition rounded-lg"
            >
              <div className="flex items-start gap-3 p-4 bg-white rounded-lg shadow-sm">
                <img
                  src={getAvatarURL(user)}
                  alt={user.name}
                  className="w-14 h-14 rounded-full object-cover"
                />
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 leading-snug">
                    {user.name}
                  </h3>
                  <p className="text-sm text-gray-500 mb-1">@{user.username}</p>
                  {user.bio && (
                    <p className="text-sm text-gray-700 mb-1 line-clamp-2">
                      {user.bio}
                    </p>
                  )}
                  {user.favoriteTags?.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1">
                      {user.favoriteTags.map((tag, i) => (
                        <span
                          key={i}
                          className="text-xs bg-gray-100 text-gray-700 px-2 py-0.5 rounded-full"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          ))}
          <div id="scroll-trigger" className="h-1"></div>
          {isFetching && (
            <div className="text-center mt-4">
              <BrandSpinner />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Community;
